import { render, staticRenderFns } from "./SelectCustomerTable.vue?vue&type=template&id=aa5bc4d4&"
import script from "./SelectCustomerTable.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports